(() => {
  if (window.__homebornGoogleStoreBadgeLoaded) return;

  window.__homebornGoogleStoreBadgeLoaded = true;

  const detailsSelector = '.homeborn-google-store-badge__details';

  const updatePanelTop = () => {
    const header = document.querySelector('.section-header') || document.querySelector('.header-wrapper');

    if (!header) return;

    document.documentElement.style.setProperty(
      '--homeborn-google-store-badge-panel-top',
      `${Math.ceil(header.getBoundingClientRect().bottom) + 8}px`
    );
  };

  const closeOpenBadges = (except) => {
    document.querySelectorAll(`${detailsSelector}[open]`).forEach((details) => {
      if (details !== except) details.open = false;
    });
  };

  const updateOpenBadgePanel = () => {
    if (document.querySelector(`${detailsSelector}[open]`)) updatePanelTop();
  };

  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;

      if (!(details instanceof HTMLDetailsElement)) return;
      if (!details.matches(detailsSelector)) return;
      if (!details.open) return;

      updatePanelTop();
      closeOpenBadges(details);
    },
    true
  );

  document.addEventListener('click', (event) => {
    document.querySelectorAll(`${detailsSelector}[open]`).forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeOpenBadges();
  });

  window.addEventListener('resize', updateOpenBadgePanel);
  window.addEventListener('scroll', updateOpenBadgePanel, { passive: true });
})();
